export default "__VITE_ASSET__Dxi5RFEA__"